var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientsListTable',{attrs:{"clientsList":_vm.clientsList,"loadingState":_vm.loadingState,"loadingText":_vm.loadingText,"loggedInUserName":_vm.loggedInUserName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }